<div class="loading">
    <div class="overlay"></div>
    <div class="spinner">
        <mat-spinner [strokeWidth]="5" [diameter]="50"></mat-spinner>
    </div>
</div>